// import moment from 'moment'
import 'slick-carousel/slick/slick';

import 'magnific-popup';
import AOS from "aos";

jQuery(document).ready(function ($) {

  function addSmoothScrolling() {
    $('a[href^="#"]').on('click', function (e) {
      e.preventDefault();

      var targetId = $(this).attr("href");
      var $target = $(targetId);

      if ($target.length) {
        $('html, body').animate({ scrollTop: $target.offset().top }, 'slow');
      }
    });
  }

  addSmoothScrolling();

  AOS.init({
    once: true,
    duration: 600,
    offset: 120,
  });

  // -----------------------------
  // Gallery: Slick + Filters
  // -----------------------------
  var $gallery = $('.gallery-carousel');
  var $filterBtns = $('.gallery-filters .gallery-filter');

  function initGallerySlick() {
    $gallery.slick({
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      rows: 2,
      slidesPerRow: 1,
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="slick-prev custom-arrow" aria-label="Previous">' +
        '<img src="./dist/img/icon/left.svg" alt="Previous">' +
        '</button>',
      nextArrow:
        '<button type="button" class="slick-next custom-arrow" aria-label="Next">' +
        '<img src="./dist/img/icon/right.svg" alt="Next">' +
        '</button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: { slidesToShow: 4, slidesToScroll: 4, rows: 2 }
        },
        {
          breakpoint: 900,
          settings: { slidesToShow: 2, slidesToScroll: 2, rows: 1 }
        },
        {
          breakpoint: 600,
          settings: { slidesToShow: 1, slidesToScroll: 1, rows: 1 }
        }
      ]
    });
  }

  if ($gallery.length) {
    var $allItems = $gallery.children('.gallery-item').clone();

    // init slick
    initGallerySlick();

    function renderGalleryItems(filter) {
      $gallery.empty();

      if (!filter || filter === 'all') {
        $gallery.append($allItems.clone());
        return;
      }

      $gallery.append(
        $allItems.filter('[data-gallery-group="' + filter + '"]').clone()
      );
    }

    function applyGalleryFilter(filter) {
      var safeFilter = filter || 'all';

      if ($gallery.hasClass('slick-initialized')) {
        $gallery.slick('unslick');
      }

      renderGalleryItems(safeFilter);
      initGallerySlick();
    }

    // filter clicks (toggle active filter off on second click)
    if ($filterBtns.length) {
      $filterBtns.on('click', function (e) {
        e.preventDefault();

        var $btn = $(this);
        var filter = $btn.data('filter');
        var isActive = $btn.hasClass('is-active');

        if (isActive) {
          $btn.removeClass('is-active').attr('aria-pressed', 'false');
          $btn.blur();
          applyGalleryFilter('all');
          return;
        }
 
        $filterBtns.removeClass('is-active').attr('aria-pressed', 'false');
        $btn.addClass('is-active').attr('aria-pressed', 'true');
        $btn.blur();
        applyGalleryFilter(filter);
      });
    }

    // -----------------------------
    // Gallery: Magnific Popup 
    // -----------------------------
    $gallery.magnificPopup({
      delegate: 'a.gallery-item',
      type: 'image',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        arrowMarkup:
          '<button title="%title%" type="button" class="mfp-arrow-%dir% mfp-arrow">' +
          '<img src="./dist/img/icon/%dir%.svg" alt="">' +
          '</button>',
        tPrev: 'Previous (Left arrow key)',
        tNext: 'Next (Right arrow key)',
      },
      mainClass: 'mfp-fade'
    });
  }

});
